

























































import Vue from 'vue';
import i18n from 'vue-i18n';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';
import { v4 as uuidv4 } from 'uuid';

Vue.use(i18n);

const COLLAPSIBLE_TRANSITION_DURATION = '300ms';

export default {
    name: 'CoCollapsible',
    // Let option state and expansion share the existing open prop through Vue 2 v-model.
    model: {
        prop: 'open',
        event: 'update:open',
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        defaultOpen: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        animation: {
            type: String,
            default: 'slide-down',
            validator: (value: string) =>
                ['none', 'slide-up', 'slide-down', 'slide-left', 'slide-right'].includes(value),
        },
        iconClosed: {
            type: String,
            default: 'chevron-down',
        },
        iconOpen: {
            type: String,
            default: 'chevron-up',
        },
        hideIcon: {
            type: Boolean,
            default: false,
        },
        open: {
            type: Boolean,
            default: null,
        },
        variant: {
            type: String,
            default: 'default',
            validator: (value: string) => ['default', 'white'].includes(value),
            required: false,
        },
        // Control trigger behavior independently from the existing visual variant.
        mode: {
            type: String,
            default: 'default',
            validator: (value: string) => ['default', 'switch'].includes(value),
        },
    },
    components: {
        CoIcon,
        CoSwitch,
    },
    data() {
        return {
            contentId: `co-collapsible-${uuidv4()}`,
            openState: this.open !== null ? this.open : this.defaultOpen,
        };
    },
    watch: {
        open(newVal) {
            if (newVal !== null) {
                this.openState = newVal;
            }
        },
    },
    methods: {
        prepareHeightTransition(element: HTMLElement, height: string) {
            const contentElement = element;

            // Keep the content clipped to its own area so the slide animation never crosses the trigger row.
            contentElement.style.height = height;
            contentElement.style.overflow = 'hidden';
            contentElement.style.transition = `height ${COLLAPSIBLE_TRANSITION_DURATION} ease-in-out`;
        },
        beforeEnter(element: HTMLElement) {
            this.prepareHeightTransition(element, '0px');
        },
        enter(element: HTMLElement) {
            const contentElement = element;

            requestAnimationFrame(() => {
                contentElement.style.height = `${contentElement.scrollHeight}px`;
            });
        },
        afterEnter(element: HTMLElement) {
            const contentElement = element;

            contentElement.style.height = 'auto';
            contentElement.style.overflow = '';
            contentElement.style.transition = '';
        },
        beforeLeave(element: HTMLElement) {
            this.prepareHeightTransition(element, `${element.scrollHeight}px`);
        },
        leave(element: HTMLElement) {
            const contentElement = element;

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    contentElement.style.height = '0px';
                });
            });
        },
        afterLeave(element: HTMLElement) {
            const contentElement = element;

            contentElement.style.height = '';
            contentElement.style.overflow = '';
            contentElement.style.transition = '';
        },
        toggle() {
            this.setOpen(!this.openState);
        },
        show() {
            this.setOpen(true);
        },
        hide() {
            this.setOpen(false);
        },
        setOpen(next: boolean) {
            if (this.disabled || (this.open !== null && this.mode !== 'switch') || next === this.openState) return;
            // Controlled switches request a parent update; uncontrolled panels own their state.
            if (this.open === null) this.openState = next;
            this.$emit('update:open', next);
        },
    },
};
